module.exports = __webpack_public_path__ + "cluck.mp3";